import React from 'react';
import CloneAssessment from './CloneAssessment';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import Page from 'App/components/Page';

function CloneAssessmentPage() {
    return (
        <Page title="Clone Assessment" showPageTitle permissionType={PERMISSION_TYPES.CLONE_ASSESSMENT}>
            <CloneAssessment />
        </Page>
    );
}

export default CloneAssessmentPage;
